import { apiClient } from '../../../../api/axios';
import type { ApiResponse, Category } from '../common/types';
import type { CreateCategoryPayload, UpdateCategoryPayload } from './types';

export const categoryService = {
    getAllCategories: async (status?: boolean): Promise<ApiResponse<Category[]>> => {
        const url = status !== undefined ? `/Category/GetAllCategory?status=${status}` : '/Category/GetAllCategory';
        const response = await apiClient.get(url);
        return response.data;
    },

    createCategory: async (payload: CreateCategoryPayload): Promise<ApiResponse<Category>> => {
        const response = await apiClient.post('/Category/CreateCategory', payload);
        return response.data;
    },

    updateCategory: async (payload: UpdateCategoryPayload): Promise<ApiResponse<Category>> => {
        const response = await apiClient.post(`/Category/UpdateCategory`, payload);
        return response.data;
    },

    deleteCategory: async (id: number): Promise<ApiResponse<void>> => {
        const response = await apiClient.post(`/Category/DeleteCategory?id=${id}`);
        return response.data;
    },

    toggleCategoryStatus: async (id: number, status: boolean): Promise<ApiResponse<void>> => {
        const response = await apiClient.post(`/Category/DeactivateAndActivateCategory?Id=${id}&status=${status}`);
        return response.data;
    },
};
